import styled from 'styled-components';
import { SmallPortalTooltip } from '../../Tooltip';
import { PSmall } from '../../elements/Text';
import { TooltipContent, TooltipDetail } from '../Progress/Tooltip';

const NameText = styled(PSmall)<{ isBold: boolean }>`
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  padding: 0;
`;

const NameContainer = styled.div`
  overflow: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function NameCellContents({
  name,
  email,
  tooltipId,
  isBold = false,
  role,
}: {
  name: string;
  email: string;
  tooltipId: string;
  isBold?: boolean;
  role?: string | null;
}) {
  return (
    <NameContainer className={tooltipId}>
      <NameText isBold={isBold}>{name ?? 'N/A'}</NameText>
      <SmallPortalTooltip anchorSelect={`.${tooltipId}`}>
        <TooltipContent>
          <TooltipDetail>{email}</TooltipDetail>
          {role && <TooltipDetail>Role: {role}</TooltipDetail>}
        </TooltipContent>
      </SmallPortalTooltip>
    </NameContainer>
  );
}
